import { DndContext, DragOverlay, pointerWithin } from "@dnd-kit/core";
import React, { useEffect, useState } from "react";
import { IBasicDetails, ITreeNode } from "../../../../interface/interfaces";
import { clearDragging, clearOverTempNodeId, setDragging, setOverTempNodeId } from "./dashboardDragAndDrop.slice";
import { useAppDispatch } from "../../../../redux/hooks";
import { DashboardCard } from "../DashboardCard";
import {restrictToWindowEdges} from "@dnd-kit/modifiers";


interface IDragAndDropContextWrapperProps {
    children: React.ReactNode;
    overlayElement?: JSX.Element;
}

export const DragAndDropContextWrapper: React.FC<IDragAndDropContextWrapperProps> = ({children, overlayElement=<div>Overlay element</div>}) => {
    const [activeNode, setActiveNode] = useState<IBasicDetails | null>(null);
    const dispatch = useAppDispatch();
    
    return (
        <DndContext
            collisionDetection={pointerWithin}
            autoScroll={false}

            onDragStart={(event) => {                
                dispatch(setDragging({dragging: true, dragNode: event.active.data.current as IBasicDetails}))
                setActiveNode(event.active.data.current as IBasicDetails | null)
            }}

            onDragEnd={(event) => {
                const overNode = event.over?.data.current as IBasicDetails;
                dispatch(setDragging({
                    dragging: false, 
                    dragNode: event.active.data.current as IBasicDetails,
                    overNode:
                        event.over?.data.current 
                        ? 
                        {
                            Id: overNode.Id,
                            Name: overNode.Name, 
                            Parent: overNode.Parent, 
                            Type: overNode.Type, 
                            path: overNode.path, 
                            StatusList: overNode.StatusList, 
                            NumberOfPassengers: overNode.NumberOfPassengers, 
                            Children: overNode.Children, 
                            StatusScale: overNode.StatusScale, 
                            StatusBar: overNode.StatusBar
                        }
                        :
                        undefined
                }))
                
                setActiveNode(null)
                dispatch(clearOverTempNodeId())
            }}

            onDragOver={(event)=> {
                
                if (event.over) {
                    const droppableElement = event.over.data.current as ITreeNode;
                    dispatch(setOverTempNodeId(droppableElement.Id))
                    console.log("Dragger je iznad:",droppableElement.Id);

                    
                  } else {
                    dispatch(clearOverTempNodeId())
                    console.log("Nije iznad ničega.");
                  }
            }}
            onDragCancel={() => setActiveNode(null)}
        >
            {children}

            <DragOverlay
                // dropAnimation={{duration: 200, easing: 'cubic-bezier(0.18, 0.67, 0.6, 1.22)'}}
                // dropAnimation={null}
                // modifiers={[restrictToWindowEdges]}
                // wrapperElement="ul"
            >
                {/* {activeNode ? <DashboardCard node={activeNode}/> : null} */}
                {activeNode ? <DashboardCard node={activeNode} isOverlay={true} hasOpacityTransition = {false}/> : null}
            </DragOverlay>
        </DndContext>
    )
}


// export const DragAndDropContextWrapper: React.FC<IDragAndDropContextWrapperProps> = ({children, overlayElement=<div>Overlay element</div>}) => {
//     const [activeNode, setActiveNode] = useState<IBasicDetails | null>(null);
//     const dispatch = useAppDispatch();
    
//     return (
//         <DndContext
//             collisionDetection={pointerWithin}
//             autoScroll={false}

//             onDragStart={(event) => {
//                 dispatch(setDragging({dragging: true, dragNode: event.active.data.current as IBasicDetails}))
//                 setActiveNode(event.active.data.current as IBasicDetails | null)
//             }}
            
//             onDragEnd={(event) => {
                
//                 const overNode = event.over?.data.current as IBasicDetails;
                
//                 dispatch(setDragging({dragging: true, dragNode: event.active.data.current as IBasicDetails}))
                
//                 // if(event.over?.data.current)
//                 // {
//                 //     dispatch(setDragging({
//                 //         dragging: false, 
//                 //         dragNode: event.active.data.current as IBasicDetails, 
//                 //         // mora ovako inace izaziva max limit recurziju
//                 //         overNode: {Id: overNode.Id, Name: overNode.Name, Type: overNode.Type, path: overNode.path, StatusList: overNode.StatusList, NumberOfPassengers: overNode.NumberOfPassengers, Children: overNode.Children, StatusScale: overNode.StatusScale, StatusBar: overNode.StatusBar} as IBasicDetails
//                 //     }))
//                 // }
//                 setActiveNode(null)
//             }}

//             onDragOver={(event)=> {
                
//                 if (event.over) {
//                     const droppableElement = event.over.data.current as ITreeNode;
//                     console.log("Dragger je iznad:", droppableElement.AllRobot);
//                   } else {
//                     console.log("Nije iznad ničega.");
//                   }
//             }}
            
//             onDragCancel={() => {
//                 console.log('Drag cancelled');
//                 setActiveNode(null)
//             }}
//         >
//             {children}

//             <DragOverlay
//                 // dropAnimation={{duration: 200, easing: 'cubic-bezier(0.18, 0.67, 0.6, 1.22)'}}
//                 // dropAnimation={null}
//                 // modifiers={[restrictToWindowEdges]}
//                 // wrapperElement="ul"
//             >
//                 {/* {activeNode ? <DashboardCard node={activeNode}/> : null} */}
//                 {activeNode ? <DashboardCard node={activeNode} isOverlay={true} hasOpacityTransition = {false}/> : null}
//             </DragOverlay>
//         </DndContext>
//     )
// }


